
<list-item
  class="employee-list-item"
  :card="employee"
  v-bind="$attrs"
  v-on="$listeners"
>
  <template #image>
    <index-image :index="employee" />
  </template>

  <template #info>
    <align class="employee-list-item-info" flex>
      <div class="label">
        {{ employee.label }}
      </div>
    </align>
  </template>
</list-item>
